import { Component } from "react";

// Prevents a blank white page: if any render/effect error occurs,
// show a friendly fallback with a reload action instead of a crash.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
            padding: "24px",
            textAlign: "center",
            fontFamily: "Georgia, 'Times New Roman', serif",
          }}
        >
          <h1 style={{ fontSize: "26px", fontWeight: 400, margin: 0 }}>
            Si è verificato un problema temporaneo
          </h1>
          <p style={{ color: "#666", fontWeight: 300, margin: 0 }}>
            Ricarica la pagina per continuare.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            style={{
              background: "#000",
              color: "#fff",
              border: "none",
              padding: "12px 28px",
              fontSize: "13px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
